import { DatePipe } from '@angular/common'

import { NgModule } from '@angular/core'
import { EmptyPipe } from './empty.pipe'
import { FilterPipe } from './filter.pipe'
import { IfNullPipe } from './if-null.pipe'
import { KeysPipe } from './keys.pipe'
import { OrderByPipe } from './order-by.pipe'
import { PrintPipe } from './print.pipe'

@NgModule({
  declarations: [
    EmptyPipe,
    FilterPipe,
    IfNullPipe,
    KeysPipe,
    OrderByPipe,
    PrintPipe,
  ],
  exports: [
    EmptyPipe,
    FilterPipe,
    IfNullPipe,
    KeysPipe,
    OrderByPipe,
    PrintPipe,
  ],
  providers: [
    DatePipe
  ],
})
export class PipesModule { }
